import { render, staticRenderFns } from "./MenuSearchBox.vue?vue&type=template&id=65c1b560&"
import script from "./MenuSearchBox.vue?vue&type=script&lang=js&"
export * from "./MenuSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports